import * as ko from "knockout";

import { MapProgressTooltip } from "./mapProgressTooltip";



function openTooltip(tooltip: MapProgressTooltip): boolean {
    // Position tooltip below progress button
    const toolTipContainer = L.DomUtil.get(tooltip.id);
    const mapContainer = toolTipContainer.parentElement;
    const progressButton = mapContainer
        .getElementsByClassName("mapProgress")[0]
        .getElementsByClassName("pliButtonBar")[0]
        .getElementsByTagName("button")[0];
    const buttonOffset = L.DomUtil.getViewportOffset(progressButton);
    const mapOffset = L.DomUtil.getViewportOffset(mapContainer);
    const buttonLeft = buttonOffset.x - mapOffset.x;
    const buttonTop = buttonOffset.y - mapOffset.y;
    const halfTooltipWidth = parseInt(L.DomUtil.getStyle(toolTipContainer, "width"), 10) / 2; // Tooltip could be hidden, get width from style
    const halfButtonWidth = progressButton.offsetWidth / 2;
    const tooltipLeft = buttonLeft + halfButtonWidth - halfTooltipWidth;
    const tooltipRight = buttonTop + progressButton.offsetHeight + 7;

    L.DomUtil.setPosition(toolTipContainer, new L.Point(tooltipLeft, tooltipRight), true);

    return tooltip.show();
}


function createEventHandler(handler: () => boolean): (event: Event) => void {
    return (event: Event): void => {
        if (!handler()) {
            event.stopPropagation();
            event.preventDefault();
        }
    };
}


/**
 * pliMapTooltipButton knockout binding
 */
export var pliMapTooltipButton: ko.BindingHandler = {
    init: function initMapTooltipButton(element: HTMLElement, valueAccessor: () => MapProgressTooltip): void {

        element.addEventListener("click", createEventHandler(() => {
            const tooltip = valueAccessor();
            tooltip.disableMouseOutHiding();
            return openTooltip(tooltip);
        }));
        element.addEventListener("mouseenter", createEventHandler(() => openTooltip(valueAccessor())));
        element.addEventListener("mouseleave", createEventHandler(() => valueAccessor().mouseOut()));
    }
};


/**
 * pliMapVisibleTooltip knockout binding
 */
export var pliMapVisibleTooltip: ko.BindingHandler = {
    init: function initMapVisibleTooltip(element: any, valueAccessor: () => MapProgressTooltip): void {
        // define an onClick handle on html page
        document.getElementsByTagName("html")[0].addEventListener("click", createEventHandler(() => {
            const tooltip = valueAccessor();
            if (ko.utils.domData.get(element, element.needToCloseOnClickOutside)) {
                tooltip.hide();
                ko.utils.domData.set(element, element.needToCloseOnClickOutside, false);
            }
            return true;
        }));

        element.addEventListener("mouseenter", createEventHandler(() => openTooltip(valueAccessor())));
        element.addEventListener("mouseleave", createEventHandler(() => valueAccessor().mouseOut()));

        // define an onClick handle on the element to prevent global click event
        element.addEventListener("click", (event: Event) => event.stopPropagation());
    },


    update: function updateMapVisibleTooltip(element: any, valueAccessor: () => MapProgressTooltip): void {
        const tooltip = valueAccessor();

        if (ko.unwrap(tooltip.visible)) {
            element.style.display = "block";
            // make a delay to prevent hiding the tool tip while it showing by click from tool tip's outside
            setTimeout(() => ko.utils.domData.set(element, element.needToCloseOnClickOutside, true), 250);
        } else {
            element.style.display = "none";
        }
    }
};



// WEBPACK FOOTER //
// binding.ts